import axios from 'axios';
import type { Experience } from '@/models/experience';
import type { Project } from '@/models/project';

class ExperienceWebservice {
    public load() {
        return axios.get<Experience[]>('/experiences');
    }

    public loadByProject(project: Project) {
        return axios.get<Experience[]>('/experiences/byProject', {
            params: {
                projectId: project.id,
            },
        });
    }

    public getById(experienceId: string) {
        return axios.get<Experience>('/experiences/getById', {
            params: {
                experienceId,
            },
        });
    }

    public store(experience: Experience) {
        return axios.post('/experiences/store', {
            problem: experience.problem,
            solution: experience.solution,
            trade_id: experience.trade ? experience.trade.id : 0,
            project_id: experience.project ? experience.project.id : 0,
        });
    }

    public update(experience: Experience) {
        return axios.post('/experiences/update', {
            id: experience.id,
            problem: experience.problem,
            solution: experience.solution,
            trade_id: experience.trade ? experience.trade.id : 0,
        });
    }

    public remove(experience: Experience) {
        return axios.post('/experiences/remove', {
            id: experience.id,
        });
    }
}

export const experienceWebservice = new ExperienceWebservice();
